import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=7f6837c1&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"
import style0 from "./Photo.vue?vue&type=style&index=0&id=7f6837c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6837c1",
  null
  
)

export default component.exports